const FIELD_MAP = {
  patientName: 'patientName',
  patientBirthDate: 'patientBirthDate',
  patientPhone: 'patientPhone',
  healthInsuranceName: 'healthInsuranceName',
  // Kostenträgerkennung (IK) aus der Muster-4-Kopfzeile — Pflichtangabe für
  // die Kassenabrechnung, siehe krankenfahrten_tarife_konzept.md §11.3.
  healthInsuranceIk: 'healthInsuranceIk',
  insuranceNumber: 'insuranceNumber',
  practiceNumber: 'practiceNumber',
  physicianNumber: 'physicianNumber',
  prescriptionNumber: 'prescriptionNumber',
  approvalNumber: 'approvalNumber',
  approvalRequired: 'approvalRequired',
  approvalStatus: 'approvalStatus',
  approvalHint: 'approvalHint',
  personGroupStatus: 'personGroupStatus',
  personGroupHint: 'personGroupHint',
  personGroupSource: 'personGroupSource',
  matchedCustomerId: 'customerId',
  medicalTransportEligibilitySnapshot: 'medicalTransportEligibilitySnapshot',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  maxRides: 'maxRides',
  ridesPerWeek: 'ridesPerWeek',
  pickupAddress: 'pickupAddress',
  destinationAddress: 'destinationAddress',
  treatmentType: 'treatmentType',
  routeScope: 'routeScope',
  transportRequirementMode: 'transportRequirementMode',
  requiredCapabilities: 'requiredCapabilities',
  defaultVehicleType: 'defaultVehicleType',
  copaymentStatus: 'copaymentStatus',
  copaymentHint: 'copaymentHint',
  outboundTrip: 'outboundTrip',
  returnTrip: 'returnTrip',
};

export const mapScanToFormState = (scanResult) => {
  const fields = scanResult?.fields || {};
  const patch = {};

  Object.entries(FIELD_MAP).forEach(([source, target]) => {
    const value = fields[source];
    if (value === undefined || value === null || value === '') return;
    patch[target] = value;
  });

  patch.prescriptionScanId = scanResult?.scanId || null;
  patch.prescriptionScanRef = scanResult?.storagePath || null;
  patch.prescriptionScanConfidence = scanResult?.confidence || {};

  if (scanResult?.status === 'needs_review') {
    patch.documentStatus = 'incomplete';
  }

  return patch;
};
